import { remove } from 'lodash'

const SET_INVOICES_TOTAL = (state, payload) => {
  state.invoicesTotal = payload
}

const SET_INVOICES_SELECTED = (state, payload) => {
  state.invoicesSelected = {
    ...payload,
    errors: Object.entries(payload.errors).reduce((errors, error) => {
      if (error[0] === 'payer') {
        errors = errors.concat(error[1])
      }
      return errors
    }, [])
  }
}

const SET_TAX_COMMISSION = (state, payload) => {
  state.taxCommission = payload
}

const REMOVE_INVOICE_SELECTED = (state, invoice) => {
  remove(state.invoicesSelected.invoices, {
    id: invoice
  })
}
const RESET_INVOICES = (state) => {
  state.invoicesSelected = JSON.parse(JSON.stringify(state.initialInvoicesSelected))
}

export default {
  SET_INVOICES_TOTAL,
  SET_INVOICES_SELECTED,
  SET_TAX_COMMISSION,
  REMOVE_INVOICE_SELECTED,
  RESET_INVOICES
}



// WEBPACK FOOTER //
// ./src/features/invoices/store/mutations.js